import { useQuery } from '@tanstack/react-query';

import { userProfileContextQuery, userProfileIdentityQuery } from './queries';

/** Shares the account-scoped canonical identity query across the auth boundary and callers. */
export function useUserProfileIdentity(accountId: string) {
  return useQuery(userProfileIdentityQuery(accountId));
}

export function useUserProfileContext(accountId: string, profileRef = 'me', enabled = true) {
  return useQuery(userProfileContextQuery(accountId, profileRef, enabled));
}
